import React from 'react';
import OwnerProfile from './OwnerProfile';

const OwnerProfilePage = () => {
    return (
        <div className="container mx-auto p-4">
            <OwnerProfile />
        </div>
    );
};

export default OwnerProfilePage;
